import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthSession } from "@/hooks/useAuthSession";

const Logo = () => {
  const location = useLocation();
  const { session } = useAuthSession();
  const isLoggedIn = !!session;

  const isDashboardHome = isLoggedIn && location.pathname === "/index";

  return (
    <div className="flex items-center caret-transparent select-none">
      <Link
        to={isLoggedIn ? "/index" : "/"}
        onClick={(e) => {
          if (isDashboardHome) e.preventDefault();
        }}
        aria-current={isDashboardHome ? "page" : undefined}
        className="hover:opacity-80 transition-opacity"
      >
        <img
          src={"/logo-final.png"}
          alt="Salesby Logo"
          className="h-10 w-auto object-contain rounded-lg"
          loading="eager"
        />
      </Link>
    </div>
  );
};

export default Logo;
